import { connect } from 'react-redux';
import _ from 'lodash';

// import { getItems } from 'routes/admin/actions';
import Main from './Main';

const mapState = state => ({
	user: state.user,
	categories: _.get(state, 'categories', {}),
	items: _.get(state, 'items.data', {}),
	settings: _.get(state, 'settings', {}),
});

const mapDispatch = {};

export default connect(
	mapState,
	mapDispatch
)(Main);
